import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service.jsx";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";
import TwoComparisionBarChart from "../../../Components/Charts/TwoComparisionBarChart.js";

// Define the desired custom month order
const customMonthOrder = [
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
  "Jan",
  "Feb",
  "Mar",
];

// Function to fetch and process data
const SamridhiApi = async (body) => {
  try {
    const res = await axInst.post("dealer-review/samridhi", body);
    const responseData = res.data;

    if (!Array.isArray(responseData)) {
      console.error("Invalid API response format:", responseData);
      return [];
    }

    // Process and sort data based on custom month order
    return responseData
      .map((item) => {
        const { month, years } = item;
        const sortedYears = Object.keys(years).sort((a, b) => b - a); // Sort years in descending order

        return {
          key: month, // X-axis value
          mtd: { value: years?.[sortedYears[0]] ?? 0 }, // Latest year
          lmtd: { value: years?.[sortedYears[1]] ?? 0 }, // Previous year
          years: sortedYears, // Store years for legend
          sortIndex: customMonthOrder.indexOf(month), // Store index for sorting
        };
      })
      .filter((item) => item.sortIndex !== -1) // Remove items not in our custom order
      .sort((a, b) => a.sortIndex - b.sortIndex); // Sort based on custom order index
  } catch (error) {
    console.error("Error fetching CPSC data:", error);
    return [];
  }
};

const Samridhi = () => {
  const { data, submitted } = useSelector((e) => e.filtersDealerReview);

  // Fetch stock data using react-query
  const {
    data: samridhiData = [],
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["Samridhi", submitted],
    queryFn: () => SamridhiApi(data),
    cacheTime: 0,
    staleTime: 0,
  });

  // Ensure samridhiData is an array
  const safeSamridhiData = Array.isArray(samridhiData) ? samridhiData : [];
  const legendData = safeSamridhiData.length
    ? safeSamridhiData[0].years.map((year) => `FY-${year}`)
    : [];

  return (
    <div className="bg-white rounded-md p-2 shadow-lg relative h-full">
      <WaterMark />
      {isFetching ? (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      ) : isError || safeSamridhiData.length === 0 ? (
        <div className="grid items-center justify-center w-full h-full">
          <p>Data not available</p>
        </div>
      ) : (
        <TwoComparisionBarChart
          data={safeSamridhiData}
          heading="Samridhi Score"
          legendData={legendData}
          ChartHeight="220px"
        />
      )}
    </div>
  );
};

export default Samridhi;
